import get from 'lodash/get'
import { createSelector } from 'reselect'

export const getState = state => state.files

export const getUploading = createSelector(getState, state => state.uploading)

export const getUploadingFile = fileId =>
  createSelector(getUploading, uploading => get(uploading, fileId))
